module.exports = __webpack_public_path__ + "img/班鲁生产2.0e715ecb.png";